import { Outlet } from "react-router-dom";
import MagicNav from "@/components/MagicNav";
import { LayoutDashboard, Building2, CreditCard, TrendingUp, ClipboardList, Globe, Database } from "lucide-react";

const items = [
  { key: "dashboard", to: "/super", end: true, label: "Dashboard", icon: LayoutDashboard },
  { key: "schools", to: "/super/schools", label: "Schools", icon: Building2 },
  { key: "subscriptions", to: "/super/subscriptions", label: "Plans", icon: CreditCard },
  { key: "revenue", to: "/super/revenue", label: "Revenue", icon: TrendingUp },
  { key: "admissions", to: "/super/admissions", label: "Admissions", icon: ClipboardList },
  { key: "website", to: "/super/website", label: "Website", icon: Globe },
  { key: "export", to: "/super/export", label: "Export", icon: Database },
];

export default function SuperLayout() {
  return (
    <div className="ep-aurora min-h-screen bg-slate-950">
      <MagicNav items={items} />
      <main className="mx-auto max-w-7xl px-5 py-8 pb-28">
        <Outlet />
      </main>
    </div>
  );
}
